// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-harsha-a-jadhav",
    "name": "Mr. Harsha A. Jadhav",
    "designation": "Assistant Professor and HOD",
    "role": "Assistant Professor and HOD",
    "qualification": "M.Tech.",
    "qualifications": "M.Tech.",
    "image": "/FacultyCImages/harsha_jadhav_CIVIL.jpeg",
    "email": "hodcivil@klsvdit.edu.in, haj@klsvdit.edu.in",
    "phone": "+91 98866 67910",
    "showPhone": true,
    "experience": "14.5 years",
    "description": "Prof. Harsha Jadhav completed B.E Civil from BEC Bagalkot and M.Tech from NITK Surathkal. From past 14 years working at KLS VDIT.",
    "bio": "Prof. Harsha Jadhav completed B.E Civil from BEC Bagalkot and M.Tech from NITK Surathkal. From past 14 years working at KLS VDIT.",
    "specializations": [
      "Pavement Design",
      "Traffic planning",
      "Town planning",
      "Software based traffic analysis"
    ],
    "areas": [
      "Pavement Design",
      "Traffic planning",
      "Town planning",
      "Software based traffic analysis"
    ],
    "courses": [
      "Highway Engineering",
      "Airport Engineering",
      "Pavement Materials",
      "Railway Engineering"
    ],
    "publications": 0,
    "projects": 0,
    "linkedin": "https://linkedin.com/in/harsha-jadhav-721909413",
    "irins": "https://klsvdit.irins.org/profile/248691",
    "recognition": [
      "information to be updated"
    ]
  },
  "members": [
    {
      "id": "f-ashik-bellary",
      "name": "Dr. Ashik Bellary",
      "designation": "Associate Professor",
      "role": "Associate Professor",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_ashik_ballary_CIVIL.jpeg",
      "email": "acb@klsvdit.edu.in",
      "phone": "+91 97382 55856",
      "showPhone": false,
      "experience": "10 years",
      "description": "Dr. Ashik C. Bellary is Associate Professor in Civil Engineering at KLS VDIT, Haliyal. He is a Justo Gold Medalist in M.E. Highway Engineering, holds a PhD from NITK Surathkal, specializes in concrete pavement design, sustainable materials, and mining waste utilization, with 10 years of experience, and has published SCI and Scopus journal articles.",
      "bio": "Dr. Ashik C. Bellary is Associate Professor in Civil Engineering at KLS VDIT, Haliyal. He is a Justo Gold Medalist in M.E. Highway Engineering, holds a PhD from NITK Surathkal, specializes in concrete pavement design, sustainable materials, and mining waste utilization, with 10 years of experience, and has published SCI and Scopus journal articles.",
      "specializations": [
        "Pavement Materials",
        "Pavement Analysis and Design",
        "Traffic Engineering",
        "Application of Artificial Intelligence (AI) and Machine Learning (ML) in Civil Engineering"
      ],
      "areas": [
        "Pavement Materials",
        "Pavement Analysis and Design",
        "Traffic Engineering",
        "Application of Artificial Intelligence (AI) and Machine Learning (ML) in Civil Engineering"
      ],
      "courses": [
        "Design And Construction Of Highway Pavements",
        "Geotechnical Engineering",
        "Concrete Technology",
        "Road Safety Engineering"
      ],
      "publications": 7,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/ashik-bellary-73191160/",
      "irins": "https://klsvdit.irins.org/profile/259179",
      "recognition": [
        "\"Ph.D Research Fellowship\", National Institute of Technology Karnataka, Surathkal, India, 2017",
        "Prof. C E G Justo Gold Medal\", in 53rd Bangalore University convocation for scoring highest marks in Master of Engineering (M.E).- Highway Engineering",
        "\"Post Graduate Scholarship (GATE)\", Ministry of Human Resource and Development, Government of India, 2014-2016",
        "\"Best Project of the Year - 2017 award\", (For Guiding the Project) in Karnataka State Council for Science and Technology (KSCST)'s Student Project Programme (SPP) exhibition held at Nitte Mahalinga Adyanthaya Memorial (NMAM) Institute of Technology, Nitte",
        "\"Chairperson\", International Conference on Sustainable Infrastructure: Innovations, Opportunities and Challenges-2023 (SIIOC-2023) organised by National Institute of Technology Karnataka (NITK) Surathkal",
        "Reviewer for International Journal of Pavement Engineering, Discover Materials and Sustainable Innovation Infrastructure Springer Publishers",
        "Successfully completed \"Indo Universal Collaboration for Engineering Education (IUCEE) International Engineering Educator Certification Program\" Spring",
        "Successfully completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certification Program on \"Machine Learning\" a six-months course at IISc (Indian Institute of Science) Bengaluru from July 2024 - December",
        "Invited as \"Guest of Honour\" for Engineers Day Celebration 2024 at Karwar organised by Association of Consulting Civil Engineers Karwar",
        "\"Member of Advisory committee\" Civil Technology (CIVITECH) Summit 2025, organised by Association of Consulting Civil Engineers, Dharwad Local Centre on 1st and 2nd March 2025",
        "Received \"Vocational Excellence Award\" on 5th September 2025 from Association of Consulting Civil Engineers (ACCE) Dharwad Local Centre (DLC)",
        "Life time member of Indian Roads Congress (IRC)",
        "Life time member of Indian Geotechnical Society (IGS)",
        "A member of Indian Society for Technical Education (ISTE)",
        "Institution of Engineers India (IEI)",
        "Life time member of Indian Concrete Institute (ICI)",
        "Certified Chartered Civil Engineer"
      ]
    },
    {
      "id": "f-siddalingayya-g-hiremath",
      "name": "Mr. Siddalingayya G Hiremath",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/s_g_hiremath_CIVIL.jpeg",
      "email": "sghalnhiremath@gmail.com",
      "phone": "+91 94486 33855",
      "showPhone": false,
      "experience": "24 years",
      "description": "Mr. Siddalingayya Gadigeyya Hiremath is an Assistant Professor in the Department of Civil Engineering at KLS VDIT. He completed his graduation from Karnataka University, Dharwad, in 1999 and earned his postgraduate degree from VTU in 2003. His academic interests and expertise focus on Environmental Engineering and related areas.",
      "bio": "Mr. Siddalingayya Gadigeyya Hiremath is an Assistant Professor in the Department of Civil Engineering at KLS VDIT. He completed his graduation from Karnataka University, Dharwad, in 1999 and earned his postgraduate degree from VTU in 2003. His academic interests and expertise focus on Environmental Engineering and related areas.",
      "specializations": [
        "Environmental Engineering"
      ],
      "areas": [
        "Environmental Engineering"
      ],
      "courses": [
        "Engineering Mechanics",
        "Water Supply And Waste Water Engineering",
        "Solid Waste Management"
      ],
      "publications": 1,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/s-g-hiremath-347b00413/",
      "irins": "https://klsvdit.irins.org/profile/248699",
      "recognition": [
        "Member of Professional Bodies Institution of Engineers India (IEI)",
        "A member of Indian Society for Technical Education (ISTE)"
      ]
    },
    {
      "id": "f-seema-basarikatti",
      "name": "Mrs. Seema Basarikatti",
      "designation": "Assistant professor",
      "role": "Assistant professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/seema_basarikatti_CIVIL.jpeg",
      "email": "srb@klsvdit.edu.in",
      "phone": "+91 78992 30208",
      "showPhone": false,
      "experience": "14 years",
      "description": "Ms. Seema Basarikatti is pursuing her Ph.D at SDMCET Dharwad under VTU. Her research interests are water resource Engineering, Hydrology & Irrigation.",
      "bio": "Ms. Seema Basarikatti is pursuing her Ph.D at SDMCET Dharwad under VTU. Her research interests are water resource Engineering, Hydrology & Irrigation.",
      "specializations": [
        "Water Resource Engineering",
        "Environmental engineering",
        "Hydrology and Hydraulics & Irrigation Engineering"
      ],
      "areas": [
        "Water Resource Engineering",
        "Environmental engineering",
        "Hydrology and Hydraulics & Irrigation Engineering"
      ],
      "courses": [
        "Fluid Mechanics",
        "Hydrology And Irrigation Engineering",
        "Engineering Survey",
        "Solid Waste Management"
      ],
      "publications": 2,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/seema-basarikatti-152466250?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://klsvdit.irins.org/profile/248741",
      "recognition": [
        "Member of Indian National Chapter of the International Association of Hydrogeologists (INC-IAH)"
      ]
    },
    {
      "id": "f-harshvardhan-v-s",
      "name": "Mr. Harshvardhan V.S.",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "image": "/FacultyCImages/harshvardhan_v_s_CIVIL.jpeg",
      "email": "hvs@klsvdit.edu.in",
      "phone": "+91 98805 71527",
      "showPhone": false,
      "experience": "10 years",
      "description": "Prof. Harshavardhan V.S. is an Assistant Professor in the Department of Civil Engineering at KLS Vishwanathrao Deshpande Institute of Technology (VDIT) in Haliyal, Karnataka.",
      "bio": "Prof. Harshavardhan V.S. is an Assistant Professor in the Department of Civil Engineering at KLS Vishwanathrao Deshpande Institute of Technology (VDIT) in Haliyal, Karnataka.",
      "specializations": [
        "Structural Engineering",
        "Geotechnical Engineering"
      ],
      "areas": [
        "Structural Engineering",
        "Geotechnical Engineering"
      ],
      "courses": [
        "Geotechnical Engineering",
        "Strength Of Material",
        "Design Of Bridges",
        "Analysis Of Structures"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/harshavardhan-v-s-43b589413/",
      "irins": "https://klsvdit.irins.org/profile/248737",
      "recognition": []
    },
    {
      "id": "f-v-s-hegde",
      "name": "Dr. V S Hegde",
      "designation": "Adjunct Faculty",
      "role": "Adjunct Faculty",
      "qualification": "Ph.D.",
      "qualifications": "Ph.D.",
      "image": "/FacultyCImages/v_s_hegde_CIVIL.jpeg",
      "email": "vshegde2009@gmail.com",
      "showPhone": false,
      "experience": "Guided 13 Ph.Ds",
      "description": "Dr. V.S. Hegde is an Adjunct Faculty in Civil Engineering. His professional focus is to explore potential for the growth of individuals, institutions and society, and develop resources for sustainable growth.",
      "bio": "Dr. V.S. Hegde is an Adjunct Faculty in Civil Engineering. His professional focus is to explore potential for the growth of individuals, institutions and society, and develop resources for sustainable growth.",
      "specializations": [
        "Coastal Geomorphology",
        "Sedimentation and coastal Zone management",
        "Hard rock Geology and Economic Geology",
        "Upland watershed management"
      ],
      "areas": [
        "Coastal Geomorphology",
        "Sedimentation and coastal Zone management",
        "Hard rock Geology and Economic Geology",
        "Upland watershed management"
      ],
      "courses": [],
      "publications": 70,
      "projects": 15,
      "linkedin": "https://www.linkedin.com/in/venkatraman-hegde-98b024a4/",
      "irins": "",
      "recognition": [
        "National Science Teacher award",
        "Completed 15 R&D Research Projects funded by Ministry of Earth Science, Govt of India (3), ISRO RESPOND (3), UGC (4), DST (1), Ministry of Mines (1), Industry (1), International (1), and VTU (1)",
        "Successfully guided 13 PhDs (8 under VTU, 3 under KUD, and 2 under NITK Surathkal)",
        "Published >70 papers in leading National and International journals in Coastal Zone Management, Hard Rock Geology, and Upland Watershed Management",
        "Selected as Education Field Officer of the European Geosciences Union",
        "Served as an Expert by VTU for development and generation of e-learning resources",
        "Working as an Expert (selected by MHRD, Govt of India) for trilingual glossary of technical words",
        "Indian National Science Academy Best Teacher Award (2013)",
        "Best Teacher Award (2008) and Publication Award (2009) by SDM College of Engineering & Technology, Dharwad",
        "Highest Consultancy Revenue Generation in the history of SDMCET during tenure as Head of the Department (2007–2009)",
        "Recipient of Visiting Fellowship of Chinese Academy of Sciences, Beijing, through the Lithosphere Institute, Chinese Academy of Sciences and Dept of Geology and Geophysics, China (2018)",
        "Recipient of INSA-DAAD Germany Bilateral Exchange Program Fellowship (2016)",
        "Norway Government Visiting Fellowship through Oslo University, Norway (2015)",
        "Visiting Fellowship of Government of Australia through University of Wollongong, Australia (2014)",
        "University of Johannesburg (South Africa) and SDMCET Joint Visiting Fellowship (2010)",
        "Visiting Scientist Fellowship by Ministry of Earth Science, Government of India and Indiana University, Bloomington, USA (2009)",
        "Presented 15 lead/key papers in national seminars and attended/presented papers in >30 conferences",
        "Organized 5 National Seminars, 4 International Seminars, and 15 Workshops as convener",
        "Collaborating with 3 National Laboratories: Space Applications Centre (SAC) Ahmedabad, National Geophysical Research Institute (NGRI) Hyderabad, and Physical Research Laboratory (PRL) Ahmedabad"
      ]
    }
  ]
};

export default facultyData;
